import React from 'react';
import PropTypes from 'prop-types';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import FormulaField from 'features/common/components/formula-field';
import { FormulaFieldContainer, FormulaFieldLabel } from 'components/common/Styles';

const FinancialIndicatorComponent = ({ financialIndicator, dispatch, styles, validation }) => {
  const { t } = useTranslation();
  const onPropertyChanged = (propertyName, propertyValue) => {
    dispatch({ type: 'OnPropertyChanged', propertyName, propertyValue });
  };

  return (
    <>
      <Prompt when={financialIndicator.changed} message={t('FinancialIndicators.LeavingWithoutSavingFinancialIndicator')} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <TextField
            isNumeric
            fullWidth
            decimalScale={0}
            value={financialIndicator.orderNo}
            onChange={event => onPropertyChanged('orderNo', event)}
            label={t('FinancialIndicators.Details.OrderNo')}
            error={!isValid(validation.orderNo)}
            helperText={getErrors(validation.orderNo)}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            value={financialIndicator.code || ''}
            onChange={event => onPropertyChanged('code', event)}
            label={t('FinancialIndicators.Details.Code')}
            error={!isValid(validation.code)}
            helperText={getErrors(validation.code)}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            value={financialIndicator.name || ''}
            onChange={event => onPropertyChanged('name', event)}
            label={t('FinancialIndicators.Details.Name')}
            error={!isValid(validation.name)}
            helperText={getErrors(validation.name)}
          />
        </Grid>
        <Grid item xs={12} sm={3} container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              isNumeric
              fullWidth
              decimalScale={0}
              value={financialIndicator.scale}
              onChange={event => onPropertyChanged('scale', event)}
              label={t('FinancialIndicators.Details.Scale')}
              error={!isValid(validation.scale)}
              helperText={getErrors(validation.scale)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              fullWidth
              value={financialIndicator.styleId}
              simpleValue
              options={styles}
              onChange={event => onPropertyChanged('styleId', event)}
              label={t('FinancialIndicators.Details.Style')}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            value={financialIndicator.attributeName || ''}
            onChange={event => onPropertyChanged('attributeName', event)}
            label={t('FinancialIndicators.Details.Attribute')}
            error={!isValid(validation.attributeName)}
            helperText={getErrors(validation.attributeName)}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            value={financialIndicator.externalCode || ''}
            onChange={event => onPropertyChanged('externalCode', event)}
            label={t('FinancialIndicators.Details.ExternalCode')}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            value={financialIndicator.comment || ''}
            onChange={event => onPropertyChanged('comment', event)}
            label={t('FinancialIndicators.Details.Comment')}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormulaFieldLabel>{t('FinancialIndicators.Details.Expression')}</FormulaFieldLabel>
          <FormulaFieldContainer>
            <FormulaField value={financialIndicator.expression} onChange={value => onPropertyChanged('expression', value)} />
          </FormulaFieldContainer>
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControlLabel
            control={<Checkbox checked={financialIndicator.readOnly || false} />}
            onChange={event => onPropertyChanged('readOnly', event.target.checked)}
            label={t('FinancialIndicators.Details.ReadOnly')}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControlLabel
            control={<Checkbox checked={financialIndicator.sensitiveInfo || false} />}
            onChange={event => onPropertyChanged('sensitiveInfo', event.target.checked)}
            label={t('FinancialIndicators.Details.SensitiveInfo')}
          />
        </Grid>
      </Grid>
    </>
  );
};

FinancialIndicatorComponent.propTypes = {
  financialIndicator: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  styles: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};
export default FinancialIndicatorComponent;
